'use client';

import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { spacing } from '../../styles/tokens.stylex';
import { Loader } from '../Loader/Loader';
export function DialogLoading() {
  return <div className="x1s48xbr x6s0dn4 xrvj5dj xl56j7k xciow05">
      <Loader size="2.5rem" />
    </div>;
}